<template>
  <div class="ms-auto w-md-auto mt-2" v-if="$store.state.page >= showFromPage">
    Ajánlati PDF letöltése vagy link generálása után jelen díjszámítás nem módosítható, újabb
    díjszámítást az Új díjszámítás indítása gombbal lehet indítani.
    <div class="ms-auto w-md-auto mt-2" v-if="!PdfRequested && $store.state.page >= showFromPage">
      <button
        @click.prevent="generateClaimIdentifier('getajanlatpdf')"
        class="btn btn-red claim-identifier"
      >
        Ajánlat pdf létrehozása
      </button>
    </div>
    <div
      class="ms-auto w-md-auto mt-2"
      v-else-if="$store.state.ajanlat_href && $store.state.page >= showFromPage"
    >
      <a :href="$store.state.ajanlat_href" target="_blank" class="btn btn-red claim-identifier"
        >Ajánlat letöltése pdf-ben</a
      >
    </div>
    <div
      class="ms-auto w-md-auto mt-2"
      v-else-if="$store.state.page >= showFromPage && !$store.state.ajanlat_href"
    >
      <button class="btn btn-red claim-identifier">
        Kérem várjon
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['showFromPage'],
  methods: {
    generateClaimIdentifier(code) {
      this.$store.commit('setClaimIdentifier', code);
      this.$store.dispatch('verifyPage');
      this.$store.commit('setNavigationBackButton', true);
      // this.$store.commit('setClaimIdentifier', '');
    },
  },
  computed: {
    ClamIdentifie() {
      return this.$store.state.code;
    },
    PdfRequested() {
      return this.$store.state.pdfrequested;
    },
  },
};
</script>
